import React, { useRef, useState } from "react";
import axios from "axios";
import "../css/pothole.css";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import homeIcon from "../assets/icons/thinkIcons/Home.png";
import accidentIcon from "../assets/img/Car-Crash.png";

const AccidentPrediction = () => {
  const [inputType, setInputType] = useState("Image");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [resultImage, setResultImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isPredicting, setIsPredicting] = useState(false);
  const resultRef = useRef(null);

  const navigate = useNavigate();

  const handleUpload = async (mode) => {
    if (!file) return;

    if (mode === "upload") setIsUploading(true);
    if (mode === "predict") setIsPredicting(true);

    const formData = new FormData();
    formData.append("file", file);

    const endpoint =
      inputType === "Video" ? "/accident/upload-video" : "/accident/upload";

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data?.output_image_url) {
        setResultImage(
          `${process.env.REACT_APP_SERVER_URL}${res.data.output_image_url}`
        );

        if (mode === "predict") {
          setTimeout(() => {
            resultRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 200);
        }
      }

      showSuccessToast(
        mode === "upload"
          ? "File Uploaded Successfully"
          : "Prediction Completed Successfully"
      );
    } catch (err) {
      console.error("Upload Error:", err);
      showErrorToast(
        mode === "upload" ? "Upload Failed!" : "Prediction Failed!"
      );
    } finally {
      if (mode === "upload") setIsUploading(false);
      if (mode === "predict") setIsPredicting(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="flex justify-end">
        <button
          className="flex items-center gap-2 border px-3 py-2 mb-2 rounded-full"
          onClick={() => navigate("/user/dashboard")}
        >
          <img src={homeIcon} alt="Home Icon" className="w-[18px] h-[18px]" />
          <span className="text-xs">Home</span>
        </button>
      </div>

      {/* Header Card */}
      <div className="card mb-4 shadow-s">
        <div className="card-body accident-header d-flex align-items-center">
          <img
            src={accidentIcon}
            alt="Accident"
            className="rounded me-3"
            style={{ width: "80px", height: "80px", objectFit: "cover" }}
          />
          <div>
            <h6 className="mb-1">Accident detection</h6>
            <p className="mb-0 text-muted">
              Automated Detection of Road Surface Damage
            </p>
          </div>
        </div>
      </div>

      <div>
        <p className="pothole-body fw-semibold">
          | Enter Accident Image/ Video for detection
        </p>

        {/* Upload Section */}
        <div className="card mb-4 accident-upload shadow-sm">
          <div className="card-body">
            <div className="row mb-3 justify-content-center">
              <div className="col-md-4 col-sm-12 text-center">
                <label htmlFor="inputType" className="form-label fw-semibold">
                  Select Input Type
                </label>
                <select
                  className="form-select text-center"
                  id="inputType"
                  value={inputType}
                  onChange={(e) => setInputType(e.target.value)}
                >
                  <option value="Image">Image</option>
                  <option value="Video">Video</option>
                </select>
              </div>
            </div>

            <div
              className="rounded p-4 accident-box text-center d-flex flex-column align-items-center justify-content-center m-auto"
              onClick={() => fileInputRef.current.click()}
            >
              <i className="bi bi-cloud-upload fs-1 mb-3 text-secondary" />
              <label className="form-label fw-bold mb-2">
                Drag & Drop OR Click to Upload
              </label>
              <input
                type="file"
                accept={inputType === "Image" ? "image/*" : "video/*"}
                ref={fileInputRef}
                onChange={(e) => setFile(e.target.files[0])}
                style={{ display: "none" }}
              />
              <p className="text-muted">Supported formats: PNG, JPG, MP4</p>
              <button
                className="btn accident-btn text-info mt-2 px-5"
                disabled={!file || isUploading}
                onClick={() => handleUpload("upload")}
              >
                {isUploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>

        {/* Predict Button */}
        <div className="text-center mt-4">
          <button
            className="btn text-info accident-btn px-5"
            disabled={!file || isPredicting}
            onClick={() => handleUpload("predict")}
          >
            {isPredicting ? "Predicting..." : "Predict & Deliver"}
          </button>
        </div>
      </div>

      {/* {resultImage && (
        <div ref={resultRef} className="card shadow-sm mt-4">
          <div className="card-body">
            <h6 className="text-primary fw-semibold">Accident prediction</h6>
            <p className="text-muted mb-2">
              Automated Detection of Road Surface Damage
            </p>
            <h6 className="fw-semibold text-success">Prediction Result</h6>

            <div className="d-flex justify-content-center h-50">
              {inputType === "Image" ? (
                <img
                  src={resultImage}
                  alt="Prediction"
                  className="img-fluid rounded border mt-3"
                />
              ) : (
                <video
                  src={resultImage}
                  controls
                  className="img-fluid rounded border mt-3"
                />
              )}
            </div>
          </div>
        </div>
      )} */}

      {resultImage && (
        <div ref={resultRef} className="card shadow-sm mt-4">
          <div className="card-body">
            <h6 className="text-primary fw-semibold">Accident prediction</h6>
            <p className="text-muted mb-2">
              Automated Detection of Road Surface Damage
            </p>
            <h6 className="fw-semibold text-success">Prediction Result</h6>

            <div className="d-flex justify-content-center h-50">
              {inputType === "Image" ? (
                <img
                  src={resultImage}
                  alt="Prediction"
                  className="img-fluid rounded border mt-3"
                />
              ) : (
                <a
                  href={resultImage}
                  download={`accident_result_${Date.now()}.mp4`}
                  className="btn btn-success mt-3"
                >
                  Download Processed Video
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccidentPrediction;
